import './Basic.css';

function Privacy() {

    return (
    <div className="Terms">
        <main>
            <h1>Privacy Policy</h1>
            <p>Effective Date: 11/14/25</p>
            <p>Catastrobee (“we”, “us”, or “our”) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you interact with our services, including when you opt in to receive SMS or MMS messages from us.</p>

            <h2>Information We Collect</h2>
            <p>We may collect personal information such as your name, phone number, and any other information you provide when you opt in to receive messages from us.</p>

            <h2>How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul>
                <li>Send you SMS or MMS messages related to the Catastrobee film.</li>
                <li>Respond to your inquiries and provide customer support.</li>
                <li>Improve our services.</li>
                <li>Data Sharing and Disclosure</li>
                <li>No mobile information will be shared with third parties/affiliates for marketing/promotional purposes. We do not sell, rent, or share your mobile information with third parties for their marketing or promotional use.</li>
            </ul>

            <h2>We may share your information:</h2>
            <ul>
                <li>As required by law or to comply with legal processes.</li>
                <li>To protect the rights, property, or safety of Hive Productions, our users, or others.</li>
                <li>Data Security</li>
                <li>We implement reasonable security measures to protect your information from unauthorized access, use, or disclosure.</li>
            </ul>

            <h2>Your Choices</h2>
            <p>You may opt out of receiving messages at any time by replying “STOP” to any message you receive from us. For help, reply “HELP” or contact us at catastrobeemovie@gmail.com.</p>

            <h2>Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.</p>

            <h2>Contact Us</h2>
            <p>If you have any questions about this Privacy Policy, please contact us at catastrobeemovie@gmail.com</p>
        </main>
    </div>
  );
}

export default Privacy;